/**
 * Summary
 * The ModalContainer component orchestrates the display of various
 * modal windows. Each Modal component is a separate resource for
 * displaying a specific window - meaning only one should be in view
 * at any time. This component fulfills the role of HOC to control
 * whether a modal should be displayed, and which.
 */

import React from "react";
import { useModal } from "../_contexts";

//Modals
import {
  HelpModal,
  IntroModal,
  NewTimeline,
  NewEvent,
  MapManager,
  NewMap,
  MapMarkerModal,
  DeleteConfirmationModal,
  TimelineManager,
  ImageManager,
  ImageModal,
  OnboardEnd,
  ChronicleSettings,
  ChronosTester,
  EventManager,
  MarkerTemplates,
  MarkerTemplateEditor,
  CalendarManager,
} from "./";

export function ModalContainer() {
  const { activeModal, modalParams } = useModal();

  let modal = null;
  switch (activeModal) {
    case "help":
      modal = <HelpModal {...modalParams} />;
      break;
    case "intro":
      modal = <IntroModal />;
      break;
    case "newTimeline":
      modal = <NewTimeline {...modalParams} />;
      break;
    case "newEvent":
      modal = <NewEvent {...modalParams} />;
      break;
    case "mapManager":
      modal = <MapManager {...modalParams} />;
      break;
    case "newMap":
    case "editMap":
      modal = <NewMap {...modalParams} />;
      break;
    case "mapMarker":
      modal = <MapMarkerModal {...modalParams} />;
      break;
    case "timelineManager":
      modal = <TimelineManager {...modalParams} />;
      break;
    case "confirmDelete":
      modal = <DeleteConfirmationModal {...modalParams} />;
      break;
    case "imageManager": {
      modal = <ImageManager {...modalParams} />;
      break;
    }
    case "imageModal": {
      modal = <ImageModal {...modalParams} />;
      break;
    }
    case "onboardingEnd": {
      modal = <OnboardEnd {...modalParams} />;
      break;
    }
    case "chronicleSettings": {
      modal = <ChronicleSettings {...modalParams} />;
      break;
    }
    case "chronosTest": {
      modal = <ChronosTester />;
      break;
    }
    case "eventManager": {
      modal = <EventManager {...modalParams} />;
      break;
    }
    case "markerTemplateManager": {
      modal = <MarkerTemplates {...modalParams} />;
      break;
    }
    case "markerTemplateEditor": {
      modal = <MarkerTemplateEditor {...modalParams} />;
      break;
    }
    case "calendarManager": {
      modal = <CalendarManager {...modalParams} />;
      break;
    }
    default:
      modal = null;
  }

  return modal;
}
